module.exports = __webpack_public_path__ + "static/img/liBgImage2.090a09c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/industryApplication/tab1/liBgImage2.png
// module id = FenK
// module chunks = 0